import React from 'react';

import { widgets } from 'modules';



export interface IProps {
  storeId: string;
}

export const FC: React.FC<IProps> = props => {
  return (
    <widgets.store.BrandSettingsWidget.FC storeId={props.storeId} />
  );
};
